var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 0.5H1.75C1.125 0.5 0.5 1.125 0.5 1.75V14.25C0.5 14.875 1.125 15.5 1.75 15.5H14.25C14.875 15.5 15.5 14.875 15.5 14.25V1.75C15.5 1.125 14.875 0.5 14.25 0.5ZM9.25 11.75H6.75V13H9.25V11.75ZM10.5 11.75H13V13H10.5V11.75ZM5.5 11.75H3V13H5.5V11.75Z",
    fill: "#213B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlain);
export default __webpack_public_path__ + "static/media/plain.4a96b5504f2cc114729125bd2fb1356c.svg";
export { ForwardRef as ReactComponent };